var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"like_component",style:({ width: _vm.size == 'medium' ? '32px' : '', height: _vm.size == 'medium' ? '32px' : ''}),on:{"click":_vm.likeResource}},[_c('img',{style:({ height: _vm.size == 'medium' ? '24px' : ''}),attrs:{"src":_vm.showImg(),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }